import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SaveProject = () => {
    const { t } = useTranslation();

    const { hasActiveProject, isDirty, isSaving } = usePlacementStore(
        useShallow((state) => ({
            hasActiveProject: state.activeProject !== null,
            isDirty: state.isDirty,
            isSaving: state.isSaving
        }))
    );

    return (
        <Menu.Item
            disabled={!hasActiveProject || isSaving || !isDirty}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="save" />
            }
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralSave} />}
            onClick={() => window.dispatchEvent(new Event(projectsMenuEvents.triggerSave))}
        >
            {t('labelSaveProject')}
        </Menu.Item>
    );
};
